interface RawResource {
  id: string
  title: string
  link: string
}

export default function buildResourceWidgets(
  resourceData: RawResource[],
  baseOmrUrl: string,
  productTitle: string,
  reviewsPDPUrlWidget: string,
) {
  const resources = resourceData.map((resource, index) => {
    return {
      id: resource.id ?? index,
      title: resource.title,
      src: baseOmrUrl + resource.link,
      // width only: a fixed height would distort the widget's non-square aspect ratio
      link: `<a title='${productTitle}' href='${reviewsPDPUrlWidget}'><img src='${baseOmrUrl}${resource.link}' alt='OMR - Rating Widget' width='200' /></a>`,
    }
  })
  return resources
}
